module.exports = __webpack_public_path__ + "teqbahn-assets/media/logo_Speakup.93145236.png";